import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { routes } from '../routs';

const routess: Routes = [
  {
    path: '',
    loadChildren: () => import('../../pages/start/start.module').then(m => m.StartModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild([...routess, ...routes])],
  exports: [RouterModule]
})
export class LangUaRoutingModule { }
